import { useEffect } from 'react';

// Custom React hook for setting up speech recognition
export function useSpeechRecognition({
  finalRef,
  setInput,
  setListening,
  setSupported,
  recognitionRef,
  lang = 'en-US',
  continuous = true,
  interimResults = true,
}) {
  useEffect(() => {
    const recognition = createSpeechRecognition({
      onResult: (event) => {
        let interim = "";
        let finalAccum = finalRef.current || "";
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            finalAccum += transcript;
          } else {
            interim += transcript;
          }
        }
        finalRef.current = finalAccum;
        setInput(finalAccum + interim);
      },
      onError: (err) => {
        console.error("Speech recognition error:", err);
      },
      onEnd: () => {
        setListening(false);
      },
      lang,
      continuous,
      interimResults,
    });
    if (!recognition) {
      setSupported(false);
      return;
    }
    recognitionRef.current = recognition;
    return () => {
      recognition && recognition.stop();
    };
  }, [finalRef, setInput, setListening, setSupported, recognitionRef, lang, continuous, interimResults]);
}
// utils/speechRecognition.js
// Utility for setting up Speech Recognition (Web Speech API)

export function createSpeechRecognition({
  onResult,
  onError,
  onEnd,
  lang = 'en-US',
  continuous = true,
  interimResults = true,
} = {}) {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SpeechRecognition) {
    return null;
  }
  const recognition = new SpeechRecognition();
  recognition.continuous = continuous;
  recognition.interimResults = interimResults;
  recognition.lang = lang;
  if (onResult) recognition.onresult = onResult;
  if (onError) recognition.onerror = onError;
  if (onEnd) recognition.onend = onEnd;
  return recognition;
}
